import { Box, customStyled, Text, Flex } from '@mafc/trolly';
import { layout, typography } from 'styled-system';
import React from 'react';

export const CustomBox = (props: any) => <Box display="block" {...props} />;

export const Container = customStyled(CustomBox)(layout, typography);

export const CardOnDeliveryContainer = customStyled(Flex)(props => ({
  alignItems: 'center',
  color: props.theme.colors.black,
}));
